document.addEventListener('DOMContentLoaded', function () {
  var videoBlocks = document.querySelectorAll('.gf-youtube-consent');

  videoBlocks.forEach(function (block) {
    var button = block.querySelector('.gf-youtube-consent-button');

    if (!button) return;

    button.addEventListener('click', function () {
      var videoId = block.getAttribute('data-video-id');
      var title = block.getAttribute('data-video-title') || 'YouTube Video';

      if (!videoId) return;

      var iframeWrapper = document.createElement('div');
      iframeWrapper.style.position = 'relative';
      iframeWrapper.style.paddingBottom = '56.25%';
      iframeWrapper.style.height = '0';
      iframeWrapper.style.overflow = 'hidden';
      iframeWrapper.style.maxWidth = '100%';

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?rel=0&autoplay=1';
      iframe.title = title;
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';

      iframeWrapper.appendChild(iframe);
      block.replaceWith(iframeWrapper);
    });
  });
});